import { observable } from 'mobx'

export default class myProjectsPrefStore {
  @observable data = []
  @observable sessionData = []
  @observable issueData = []
  @observable created = false
  @observable prefDatasetId = ''
  @observable currentIssue = []
  @observable currentIssuePercent = 0
  @observable delIssueId = ''

  updateCurrentIssue(id) {
    var indexIssue = this.sessionData.issues
      .map(x => {
        return x.id
      })
      .indexOf(id)
    if (indexIssue !== -1) {
      this.currentIssue = this.sessionData.issues[indexIssue]
      var e = parseInt(this.currentIssue.minsEstimate, 10)
      var s = parseInt(this.currentIssue.minsSpend, 10)
      if (e > 0 && e <= s) {
        this.currentIssuePercent = 100
      } else {
        this.currentIssuePercent = parseInt(s * 100 / e, 10)
      }
    }
  }

  updateData(data) {
    this.data = data
  }

  updateSessionData(data) {
    this.sessionData = data
  }

  updateDataBySession() {
    var index = this.data
      .map(x => {
        return x.id
      })
      .indexOf(this.sessionData.id)
    this.data[index] = this.sessionData
  }

  updateSessionByIssue() {
    var indexIssue = this.sessionData.issues
      .map(x => {
        return x.id
      })
      .indexOf(this.issueData.id)

    if (indexIssue === -1) {
      this.sessionData.issues.splice(0, 0, this.issueData)
    } else {
      this.sessionData.issues[indexIssue] = this.issueData
    }
  }

  updateIssueData(issue) {
    this.issueData = issue
  }

  updateCreated() {
    this.created = true
  }

  updateProgress(max) {
    this.sessionData.maxPage = max
    this.sessionData.percentRead = parseInt(
      100 * (parseInt(max, 10) / parseInt(this.sessionData.totalPages, 10)),
      10
    )
    var index = this.data.findIndex(obj => obj.id === this.sessionData.id)
    this.data[index]['maxPage'] = this.sessionData.maxPage
    this.data[index]['percentRead'] = this.sessionData.percentRead
  }

  updateTimeSpend(mins, pId, iId, iName) {
    if (
      pId === this.sessionData.id &&
      iId === this.currentIssue.id &&
      this.currentIssue.issueName === iName
    ) {
      this.currentIssue.minsSpend = mins
      this.issueData = this.currentIssue
      this.updateSessionByIssue()
      this.updateDataBySession()
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/myProjectsPrefStore.js